import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { InsuranceFormValues, PatientInsurance } from 'src/app/core/models';
import { SetInsuranceUserData } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.actions';
import { OrderWizardDataState } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.state';
import {
  InsuranceUserData,
  InsuranceUserDataType,
} from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.model';

@Component({
  selector: 'app-insurance-step',
  templateUrl: './insurance-step.component.html',
  styleUrls: ['./insurance-step.component.scss'],
})
export class InsuranceStepComponent {
  @Select(OrderWizardDataState.insurance) insurance$!: Observable<PatientInsurance>;
  @Select(OrderWizardDataState.insuranceUserData) insuranceUserData$!: Observable<InsuranceUserData>;

  constructor(private store: Store) {}

  onSubmitInsurance(insuranceType: InsuranceUserDataType, values: InsuranceFormValues) {
    this.store.dispatch(new SetInsuranceUserData(insuranceType, values));
  }
}
